import { useState } from 'react';
import { IconAlertTriangle, IconCheck, IconCopy } from '@tabler/icons-react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { copyToClipboard } from '../../utils/clipboard';

function CopyIcon({ status }) {
  const Icon = status === 'copied' ? IconCheck : status === 'failed' ? IconAlertTriangle : IconCopy;
  return <Icon size={15} stroke={2.2} aria-hidden="true" />;
}

export default function CodeBlock({ code, lang }) {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);
  const copyStatus = copied ? 'copied' : failed ? 'failed' : 'idle';
  const copyLabel = copied ? '복사됨' : failed ? '복사 실패' : '복사';

  const copy = () => {
    setFailed(false);
    copyToClipboard(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      setFailed(true);
      setTimeout(() => setFailed(false), 3000);
    });
  };

  return (
    <div style={{ position: 'relative', margin: '10px 0', background: '#1e1e2e', borderRadius: '8px', overflow: 'hidden', maxWidth: '100%', boxSizing: 'border-box', border: '1px solid rgba(255,255,255,.08)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', padding: '6px 10px 6px 12px', background: 'rgba(255,255,255,.05)', borderBottom: '1px solid rgba(255,255,255,.07)', minWidth: 0 }}>
        <span style={{ fontSize: '11px', color: '#a7adba', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0, letterSpacing: 0 }}>{lang || 'code'}</span>
        <button
          onClick={copy}
          aria-label={copyLabel}
          title={copyLabel}
          style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px', background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.12)', borderRadius: '6px', padding: 0, color: '#d1d5db', cursor: 'pointer', flexShrink: 0 }}
        >
          <CopyIcon status={copyStatus} />
        </button>
      </div>
      <SyntaxHighlighter
        language={lang || 'text'}
        style={oneDark}
        customStyle={{ margin: 0, padding: '12px 14px', background: 'transparent', fontSize: '13px', lineHeight: '1.6', maxWidth: '100%', boxSizing: 'border-box', overflowX: 'auto' }}
        codeTagProps={{ style: { fontFamily: 'monospace' } }}
        wrapLongLines={false}
      >
        {code.replace(/\n$/, '')}
      </SyntaxHighlighter>
    </div>
  );
}
